/**
* Chat header component with title, status, and stop AI button
*/

import StopCircleIcon from '@mui/icons-material/StopCircle'
import PersonIcon from '@mui/icons-material/Person'

interface ChatHeaderProps {
    isPaused: boolean
    onStopAI: () => void
    palette: {
        gradient: string
    }
    allowStopAI?: boolean // Allow visitors to stop AI (default: true)
    logoUrl?: string
}

export function ChatHeader({ isPaused, onStopAI, palette, allowStopAI = true, logoUrl }: ChatHeaderProps) {
    return (
        <div
        style={{
            padding: '16px 18px',
            borderBottom: `1px solid rgba(255,255,255,0.08)`,
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            background: palette.gradient,
            color: '#ffffff',
            borderTopLeftRadius: '24px',
            borderTopRightRadius: '24px',
        }}
        >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
        {logoUrl && (
            <img
            src={logoUrl}
            alt="Logo"
            style={{
                width: '40px',
                height: '40px',
                borderRadius: '8px',
                objectFit: 'contain',
                background: 'rgba(255,255,255,0.15)',
                padding: '4px',
                flexShrink: 0,
            }}
            />
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
        <span style={{ fontWeight: 600, fontSize: '15px' }}>
        Chat Support
        </span>
        <span style={{ fontSize: '13px', opacity: 0.9 }}>
        {isPaused ? 'Connected to a human agent' : 'We typically reply within a few minutes'}
        </span>
        </div>
        {!isPaused && allowStopAI && (
            <button
            type="button"
            onClick={onStopAI}
            style={{
                padding: '6px 12px',
                borderRadius: '12px',
                border: '1px solid rgba(255,255,255,0.3)',
                background: 'rgba(255,255,255,0.15)',
                color: '#ffffff',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '12px',
                fontWeight: 500,
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.25)'
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.background = 'rgba(255,255,255,0.15)'
            }}
            aria-label="Stop AI and connect to human agent"
            title="Stop AI and connect to human agent"
            >
            <StopCircleIcon style={{ width: '16px', height: '16px' }} />
            <span>Stop AI</span>
            </button>
        )}
        {isPaused && (
            <div
            style={{
                padding: '6px 12px',
                borderRadius: '12px',
                background: 'rgba(255,255,255,0.2)',
                color: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '12px',
                fontWeight: 500,
            }}
            >
            <PersonIcon style={{ width: '16px', height: '16px' }} aria-hidden="true" />
            <span>Human Agent</span>
            </div>
        )}
        </div>
        </div>
    )
}
